import {observer} from "mobx-react";
import * as React from "react";
import {UIState} from "data/UIState";
import {MilestonesDashboard} from "components/rewards/MilestonesDashboard";
import {VoidFunc} from "types/types";

interface IRewardsBarProps {
  contentScrollY: number;
  chartablePosts?: Array<any>;
  openChallengeOverview: VoidFunc;
  handleClickToRewardsPage: VoidFunc;
  handleClickToGoalsPage: VoidFunc;
  solution:any;
}

@observer
export class RewardsBar extends React.Component<IRewardsBarProps> {

  render() {

    const status = <span>{UIState.feedData.pointsDataSource.points} points</span>;
    const collapsed = true;
    /*
    const collapsed = =(UIState.fullsizedHeader - this.props.contentScrollY <= 64) || UIState.settings.OVERRIDE_COLLAPSE_DASHBOARD;


    const style = {
      height: (collapsed ? 64 : UIState.fullsizedHeader - this.props.contentScrollY) + 'px'
    };

    let dashboardContainerStyle: any = {};
    if (collapsed) {
      dashboardContainerStyle.bottom = '0px';
    } else {
      dashboardContainerStyle.top = (-this.props.contentScrollY) + 'px';
    }
    */

    const style = { height: '76px',     backgroundColor: '#fafafa' }
    const dashboardContainerStyle =  { bottom: '0px'}

    return (
      <div className="solutions" style={style}>
        <div className="dashboardContainer" style={dashboardContainerStyle}>
          <MilestonesDashboard
            chartablePosts={this.props.chartablePosts}
            handleClickToRewardsPage={this.props.handleClickToRewardsPage}
            handleClickToGoalsPage={this.props.handleClickToGoalsPage}
            pointsStatus={status}
            mini={collapsed}
            icon={"icon-badge-trophy-flat"}
            solution={this.props.solution}
          />
        </div>
        {UIState.isMobile && collapsed ? '' :
          <button className="overview" onClick={this.props.openChallengeOverview} style={{marginTop:'22px', marginRight:'20px'}}>
            {UIState.isHealthFairMode ? 'Health Fair Overview' : 'Challenge Overview'}
          </button>
        }
      </div>
    );
  }
}
